module.exports = __webpack_public_path__ + "static/img/miscu.853c8563.gif";